import { render, staticRenderFns } from "./BaseIconMessage.vue?vue&type=template&id=f54c02b6&"
import script from "./BaseIconMessage.vue?vue&type=script&lang=js&"
export * from "./BaseIconMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports